import { Grid, Paper, TextField, Typography } from "@material-ui/core";
import { HoursTimeRangesPicker } from "..";

import { BuildingLaundryOpts } from "../../../graphql/models";
import { BuildingShippingDataEditor } from "../building_shipping_data_editor";
import { ListDatesPicker } from "../list_dates_picker";
import { TimezoneAwareTimePicker } from "../timezone_aware_time_picker";
import { Dispatch, SetStateAction } from "react";

export interface BuildingLaundryOptsEditorProps {
  laundryOpts: BuildingLaundryOpts;
  onLaundryOptsChange: Dispatch<SetStateAction<BuildingLaundryOpts>>;
}

export function BuildingLaundryOptsEditor(
  props: BuildingLaundryOptsEditorProps
) {
  const { laundryOpts, onLaundryOptsChange } = props;

  const handleFieldChange = (fieldName: string) => (fieldValue: any) =>
    onLaundryOptsChange((pv) => {
      const newValue = {
        ...pv,
        [fieldName]: fieldValue,
      };

      if (
        fieldName === "preferredPickupTimeInUtcHours" &&
        pv[fieldName] === fieldValue
      ) {
        newValue[fieldName] = undefined;
      }

      return newValue;
    });

  return (
    <Paper elevation={3} style={{ width: "100%", padding: "1rem" }}>
      <Typography variant="h6">
        Impostazioni integrazione servizio di lavanderia
      </Typography>
      <Grid container spacing={3} style={{ width: "100%" }}>
        <Grid item sm={4} xs={12}>
          <Typography variant="caption">ID zona palazzo</Typography>
          <br />
          <TextField
            style={{ width: "100%" }}
            variant="outlined"
            type="number"
            defaultValue={laundryOpts.externalZoneId}
            onBlur={(e) =>
              handleFieldChange("externalZoneId")(Number(e.target.value))
            }
          />
        </Grid>
        <Grid item sm={4} xs={12}>
          <Typography variant="caption">
            Nome della città di ritiro e consegna
          </Typography>
          <br />
          <TextField
            style={{ width: "100%" }}
            variant="outlined"
            type="string"
            defaultValue={laundryOpts.cityName}
            onBlur={(e) => handleFieldChange("cityName")(e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <TimezoneAwareTimePicker
            value={laundryOpts.preferredPickupTimeInUtcHours}
            onChange={(v) =>
              handleFieldChange("preferredPickupTimeInUtcHours")(v)
            }
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="caption">
            Orari compatibili per il ritiro dei capi di lavanderia
          </Typography>
          <br />
          <HoursTimeRangesPicker
            optionsType="pickup"
            variant="outlined"
            style={{ width: "100%" }}
            value={laundryOpts.pickupTimeSlots ?? []}
            onChange={(e) => handleFieldChange("pickupTimeSlots")(e)}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="caption">
            Orari compatibili per la consegna dei capi di lavanderia
          </Typography>
          <br />
          <HoursTimeRangesPicker
            optionsType="delivery"
            variant="outlined"
            style={{ width: "100%" }}
            value={laundryOpts.deliveryTimeSlots ?? []}
            onChange={(e) => handleFieldChange("deliveryTimeSlots")(e)}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6">
            Date in cui il servizio è chiuso / bloccato
          </Typography>
          <ListDatesPicker
            value={(laundryOpts.forbiddenDates ?? []).map((v) => new Date(v))}
            onChange={(e) =>
              handleFieldChange("forbiddenDates")(e.map((v) => v.getTime()))
            }
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6">
            Informazioni per consegna e ritiro
          </Typography>
          <br />
          <BuildingShippingDataEditor
            value={laundryOpts.shippingInfo}
            onChange={(e) => handleFieldChange("shippingInfo")(e)}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}
